<template>
  <div class="content content2">
      <p class="nav">#<span>管理团队</span></p>
      <ul class="team1">
        <li v-for="(item, index) in teamList" :key="index">
          <div class="main">
            <div class="head">
              <span class="head-pic"><img :src="item.pic" alt="" ></span>
              <div class="info">
                <span class="name">{{item.name}}</span>
                <span>{{item.intro1}}</span>
                <span>{{item.intro2}}</span>
              </div>
              <img src="./symbol.png" alt="" class="symbol">
            </div>
            <div class="introduction">
              <p v-for="items in item.introduction">{{items}}</p>
            </div>
          </div>
        </li>
      </ul>
      <ul class="team">
        <li v-for="(item, index) in teamList2" :key="index">
          <div class="main">
            <div class="head">
              <span class="head-pic"><img :src="item.pic" alt=""></span>
              <div class="info">
                <span class="name">{{item.name}}</span>
                <span>{{item.intro1}}</span>
                <span>{{item.intro2}}</span>
              </div>
              <img src="./symbol.png" alt="" class="symbol">
            </div>
            <div class="introduction">
              <p v-for="items in item.introduction">{{items}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
import pic1 from './tx_cqw.png'
import pic2 from './tx_zq.png'
import pic3 from './tx_zzh.png'
import pic4 from './tx_ywx.png'
import pic5 from './tx_gr.png'
export default {
  name: 'Team',
  data () {
    return {
      teamList: [
        {
            id: 0,
            pic: pic1,
            name: '陈琦伟 教授',
            intro1: '亚商资本创始合伙人',
            intro2: '亚商集团创始人&董事长',
            introduction: [
                '投资银行和资本市场专家，亚布力企业家论坛理事。上海新沪商联合会轮值主席，多家金融机构和上市独立董事；上海交通大学安泰经济与管理学院教授；中国创业资本研究中心主任；兼任中国国家开发银行顾问；上海证券交易所专家委员等社会要职。', '其专业代表作《国际竞争论》曾获“孙冶方经济学优秀著作奖”。'
            ]
        },
        {
            id: 1,
            pic: pic2,
            name: '张琼 女士',
            intro1: '亚商资本创始合伙人',
            intro2: '亚商集团总裁',
            introduction: [
                '美国斯坦福大学商学院MSX管理学硕士，7天连锁酒店（现更名为铂涛集团并被锦江集团收购）创始人之一。在创新消费和消费升级领域具有丰富的经验，主导了包括中航三鑫、福建圣农、升达林业、丽家宝贝等多家高成长优质企业的股权投资。', '作为亚商咨询的创始人之一和总裁，策划、主持了中远收购众城，上房收购嘉丰，统一参股完达山乳业等数十起企业改制、重组和购并、跨国购并以及购并后整合；企业战略规划与海外融资等大型项目。'
            ]
        },
        {
            id: 2,
            pic: pic3,
            name: '钟志辉 先生',
            intro1: '亚商资本管理合伙人',
            intro2: '',
            introduction: [
                '深圳大学经济学学士，复旦大学MBA。在先进制造、健康医疗和TMT领域具有丰富的经验。','专注金融及投资工作近20年。先后任职中国人民银行深圳外汇中心、Vision Capital China、和晟投资、绿景集团等公司，从事投资及相关管理工作，在业内具备广泛联系。钟志辉先生负责过美信水务、赋安安全、中泰模具、丝路数码、雅视科技等多个投资项目，熟悉境内外资本市场，精于企业分析，具有良好的项目判断和实战能力。'
            ]
        }
    ],
      teamList2: [
        {
          id: 1,
          pic: pic5,
          name: '郭锐 先生',
          intro1: '亚商资本合伙人',
          intro2: '',
          introduction: [
            '先后就读于北京工商大学、中央财经大学，并获投资学硕士学位。郭锐先生在IT及互联网领域有丰富的实业和投资经验，先后任职瀛海威、中国网通等公司，从事业务管理及投资工作，在业内具备广泛联系。', '郭锐先生曾负责风际网络、北京鼎合、DATAEYE、东信时代等多个TMT项目的投资及投后管理，对TMT行业有深入的理解及投资能力。'
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.content2{
  margin-bottom: 150px;
  background: url('../../assets/bg_dot.jpg');
  padding: 140px 64px 5px 64px;
  min-width: 1200px;
  /* box-sizing: border-box; */
}
.content2 .nav{
  padding: 0 120px 0 174px;
}
.content2 .nav{
  font-size: 24px;
  color: #c70016;
  font-weight: 600;
  margin-bottom: 30px;
}
.content2 .nav span{
  font-weight: 600;
  color: #333367;
}
.content2 ul{
  width: 100%;
  display: table;
  table-layout: fixed;
  padding-top: 123px;
  /* height: 412px; */
}
.content2 ul.team1{
  min-width: 1200px;
}
.content2 ul li{
  display: table-cell;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
}
.content2 ul li .main{
  background: #fff;
  box-shadow: 0 0 16px 10px rgba(0, 0, 0, 0.03);
  display: inline-block;
  vertical-align: middle;
}
.content2 ul li .main{
   width: 95%;
   /* width: 484px; */
   /* min-width: 408px; */
   min-width: 380px;
   height: 332px;
   padding-left: 5%;
   box-sizing: border-box;
   position: relative;
   font-size: 14px;
}
.content2 .team{
  max-width: 520px;
  margin: 0 auto;
}
.content2 ul li:hover{
  transform: translateY(-18px);
  -webkit-transform: translateY(-18px);
  -moz-transform: translateY(-18px);
}
.content2 ul li:last-child{
  margin-right: 0;
}
.content2 .head{
  padding-top: 26px;
  height: 67px;
  margin-bottom: 22px;
}
.content2 .team .head{
  margin-bottom: 32px;
}
.content2 .head .head-pic{
  position: absolute;
  top: -86px;
  left: 32px;
  width: 40%;
}
/* .content2 .team .head .secondTe{
  position: absolute;
  top: -93px;
  left: 32px;
} */
.content2 .head .head-pic img{
  width: 100%;
}
.content2 .head .symbol{
  position: absolute;
  top: 38px;
  right: 2%;
}
.content2 .info{
  /* margin-left: 195px; */
  margin-left: 45%;
  text-align: left;
}
.content2 .info span{
  display: block;
  line-height: 20px;
  color: #373737;
}
.content2 .info .name{
  margin-bottom: 10px;
  font-size: 28px;
}
.content2 .introduction{
  padding-right: 32px;
  line-height: 20px;
  color: #3e3e3e;
  text-indent: 2em;
  text-align: left;
}
@media screen and (max-width: 1480px){
  .content2{
    box-sizing: border-box;
  }
  .content2 .team1 .head .head-pic{
    top: -55px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/team/team.vue